<template>
    <a href="https://1800officesolutions.com">
        <img style="height:40px" class="hidden-sm hidden-xs mr-5" src="https://1800officesolutions.com/wp-content/uploads/2024/08/1800.png" alt="">
    </a>
</template>

<script>
export default {

}
</script>
